// Wrapper that mounts a game component + a SEO content block after it.
// Used for V44 math games whose existing JSX has multiple MathShell
// instances per screen (so weaving inline SEO would touch every screen).
// Routes mount this wrapper instead of the raw game; SEO sits below the
// game UI, separated by a border, just like the QuarkForge pattern.
export function GameWithSeo({ Game, Seo }) {
  return (
    <>
      <Game />
      {Seo && (
        <div style={{
          maxWidth: 760,
          margin: "0 auto",
          padding: "32px 18px 60px",
          color: "#9A9DBE",
          fontSize: 14.5,
          lineHeight: 1.7,
        }}>
          <div style={{ paddingTop: 28, borderTop: "1px solid #1C1E2E" }}>
            <Seo />
          </div>
        </div>
      )}
    </>
  );
}
